<template>
  <b-overlay :show="Tickets === null" rounded="sm">
    <div style="height: 85vh">
      <div class="body-content-overlay" />

      <!-- Main Area -->
      <section class="chat-app-window w-100">
        <!-- Chat Content -->
        <div class="active-chat">
          <!-- Chat Navbar -->
          <div class="chat-navbar">
            <header class="chat-header">
              <!-- Avatar & Name -->
              <div class="d-flex align-items-center">
                <b-avatar
                    size="36"
                    :src="getUserAvatar()"
                    class="mr-1 cursor-pointer badge-minimal"
                />
                <div>
                  <p class="mb-0 font-weight-bold">{{ getUserFullName() }}</p>
                  <small class="text-muted">{{ getTicketStatus() }}</small>
                </div>
              </div>

              <!-- Ticket Info -->
              <div class="d-flex align-items-center">
                <b-badge :variant="getTicketTypeVariant(Tickets && Tickets.ticketType)" class="ml-2">
                  {{ getTicketTypeLabel(Tickets && Tickets.ticketType) }}
                </b-badge>
                <b-badge :variant="getStatusVariant(Tickets && Tickets.status)" class="ml-2">
                  {{ getStatusLabel(Tickets && Tickets.status) }}
                </b-badge>
              </div>
            </header>
          </div>

          <!-- User Chat Area -->
          <vue-perfect-scrollbar
              ref="refChatLogPS"
              style="min-height: 70vh"
              :settings="perfectScrollbarSettings"
              class="user-chats scroll-area"
          >
            <div v-if="Tickets && Tickets.ticketDetails && Tickets.ticketDetails.length > 0">
              <ticket-log
                  v-for="(message, index) in Tickets.ticketDetails"
                  :key="index"
                  :chat-data="message"
                  :is-admin="message.responseType === 'SupportResponse'"
                  :user-name="getUserFullName()"
                  :admin-name="admin && admin.fullName"
              />
            </div>
            <div v-else class="text-center py-5">
              <p class="text-muted">هنوز پیامی ارسال نشده است</p>
            </div>
          </vue-perfect-scrollbar>

          <!-- Message Input -->
          <b-form @submit.prevent class="chat-app-form">
            <b-input-group class="input-group-merge form-send-message mr-1">
              <b-form-input
                  @keydown.enter="SendMessage"
                  v-model="content"
                  placeholder="پاسخ شما..."
              />
            </b-input-group>
            <b-button @click="SendMessage" variant="primary" type="button">
              ارسال
            </b-button>
          </b-form>
        </div>
      </section>
    </div>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BOverlay,
  BBadge,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import TicketLog from "../../Ticket/Detail/TicketLog.vue";
import {
  TicketGetAllByParentIdRequest,
  TicketGetByIdRequest,
  TicketReplyRequest,
} from "@/libs/Api/Ticket";
import { getUserData } from "@/auth/utils";

export default {
  data() {
    return {
      ticketId: this.$route.params.id,
      user: null,
      Tickets: null,
      admin: null,
      refreshTicket: null,
      content: "",
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
    };
  },

  async created() {
    await this.GetTicketById();
    const userData = getUserData();
    this.admin = userData && userData.user;

  },

  methods: {
    async GetTicketById() {
      let _this = this;
      let ticketGetByIdRequest = new TicketGetAllByParentIdRequest(_this);

      ticketGetByIdRequest.setId(this.$route.params.id);

      await ticketGetByIdRequest.fetch(
          (content) => {
            _this.Tickets = content.data;
            console.log(_this.Tickets)
            _this.scrollToBottom();
          },
          (e) => {
            console.log(e);
            this.$toast.error("خطا در دریافت اطلاعات تیکت");
          }
      );
    },

    async SendMessage() {
      if (this.content && this.content.trim() !== "") {
        let _this = this;
        try {
          let ticketReplyRequest = new TicketReplyRequest(_this);
          let data = {
            id: this.$route.params.id,
            content: this.content,
          };
          ticketReplyRequest.setRequestParamDataObj(data);
          await ticketReplyRequest.fetch(
              () => {
                _this.GetTicketById();
                _this.content = "";
              },
              (e) => {
                console.log(e);
                this.$toast.error("خطا در ارسال پیام");
              }
          );
        } catch (error) {
          console.error(error);
          this.$toast.error("خطا در ارسال پیام");
        }
      }
    },

    getUserFullName() {
      if (this.Tickets && this.Tickets.user && this.Tickets.user.fullName) {
        return this.Tickets.user.fullName;
      }
      return "کاربر";
    },

    getUserAvatar() {
      return require("@/assets/images/logo/logo-dark.png");
    },

    getTicketStatus() {
      if (!this.Tickets) return "";
      const status = this.Tickets.status;
      const statusMap = {
        'WaitingForSupport': 'در انتظار پاسخ پشتیبان',
        'WaitingForUser': 'در انتظار پاسخ کاربر',
        'Closed': 'بسته شده',
        'InProgress': 'در حال بررسی'
      };
      return statusMap[status] || status;
    },

    getTicketTypeLabel(type) {
      const labels = {
        'Financial': 'مالی و پرداخت',
        'Courses': 'مشاهده و دانلود آموزش ها',
        'Masters': 'تدریس و مدرس ها',
        'Expert': 'متخصصین',
        'Other': 'سایر'
      };
      return labels[type] || type || 'نامشخص';
    },

    getTicketTypeVariant(type) {
      const variants = {
        'Financial': 'warning',
        'Courses': 'info',
        'Masters': 'success',
        'Expert': 'primary',
        'Other': 'secondary'
      };
      return variants[type] || 'secondary';
    },

    getStatusLabel(status) {
      const labels = {
        'WaitingForSupport': 'منتظر پاسخ',
        'WaitingForUser': 'منتظر پاسخ کاربر',
        'Closed': 'بسته شده',
        'InProgress': 'در حال بررسی'
      };
      return labels[status] || status || 'نامشخص';
    },

    getStatusVariant(status) {
      const variants = {
        'WaitingForSupport': 'warning',
        'WaitingForUser': 'info',
        'Closed': 'secondary',
        'InProgress': 'primary'
      };
      return variants[status] || 'secondary';
    },

    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.refChatLogPS) {
          const scrollEl = this.$refs.refChatLogPS.$el || this.$refs.refChatLogPS;
          if (scrollEl) {
            scrollEl.scrollTop = scrollEl.scrollHeight;
          }
        }
      });
    },

  },

  components: {
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    BOverlay,
    BBadge,
    VuePerfectScrollbar,
    TicketLog,
  },

  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
